import { Collapse } from "@mui/material";
import {
  FilterSectionWrapper,
  FilterSectionHeader,
  AllCheckboxItem,
  CheckboxListItem,
  EmptyStateMessage,
  FilterListContainer,
  SearchableFilterContainer,
} from "./FilterSection";
import PropTypes from "prop-types";

export const OEMDrawerFilterAll = ({
  categoryObjectList,
  modelObjectList,
  countryObjectList,
  ECUTypesObjectList,
  apiObjectList,
  channelOpen,
  statusOpen,
  categoryOpen,
  modelOpen,
  ecuOpen,
  countryOpen,
  ApiLevelOpen,
  paymentOpen,
  channelListchecked,
  statusListchecked,
  categoryListChecked,
  modelListChecked,
  ecuListchecked,
  countryListchecked,
  apiLevelListchecked,
  paymentListchecked,
  searchApiLevel,
  selectAllCategoryFlag,
  selectAllModelFlag,
  selectAllCountryFlag,
  selectAllECUFlag,
  selectAllApiFlag,
  channelType,
  statusArray,
  paymentArray,
  handleChannelClick,
  handleStatusClick,
  handleCategoryClick,
  handleModelClick,
  handleECUClick,
  handleCountryClick,
  handleApiLevelClick,
  handlePaymentClick,
  handleChannelToggle,
  handleStatusToggle,
  handleCategoryToggle,
  handleModelToggle,
  handleECUToggle,
  handleCountryToggle,
  handleAPILevelToggle,
  handlePaymentToggle,
  handleAllChannelsToggle,
  handleAllStatusToggle,
  handleAllCategoryToggle,
  handleAllModelToggle,
  handleAllEcuToggle,
  handleAllCountryToggle,
  handleAllApilevelToggle,
  handleAllPaymentToggle,
  handleUnselectCategory,
  handleUnselectModel,
  handleUnselectECU,
  handleUnselectCountry,
  handleUnselectApiLevel,
  handleCategorySearch,
  handleModelSearch,
  handleECUSearch,
  handleCountrySearch,
  handleApiLevelSearch,
  filteredCategory,
  filteredModel,
  filteredECUTypes,
  filteredCountry,
  filteredApiLevel,
}) => {
  return (
    <div>
      <FilterSectionWrapper id="channel">
        <FilterSectionHeader
          isOpen={channelOpen}
          onClick={handleChannelClick}
          title="Channel Types"
        />

        <FilterListContainer isOpen={channelOpen}>
        <AllCheckboxItem
          onClick={handleAllChannelsToggle}
          checked={channelListchecked.length === channelType.length}
          indeterminate={
            channelListchecked.length > 0 &&
            channelListchecked.length < channelType.length
          }
          fontWeight={
            channelListchecked.length === channelType.length
              ? "600 !important"
              : "500 !important"
          }
        />

        {channelType
          .filter((channel) => channel !== "")
          .map((channel) => (
            <CheckboxListItem
              key={channel}
              item={channel}
              isChecked={channelListchecked.includes(channel)}
              onClick={handleChannelToggle(channel)}
            />
          ))}
      </FilterListContainer>
      </FilterSectionWrapper>

      <FilterSectionWrapper id="status">
        <FilterSectionHeader
          isOpen={statusOpen}
          onClick={handleStatusClick}
          title="Status"
        />

      <FilterListContainer isOpen={statusOpen}>
        <AllCheckboxItem
          onClick={handleAllStatusToggle}
          checked={statusListchecked.length === statusArray.length}
          indeterminate={
            statusListchecked.length > 0 &&
            statusListchecked.length < statusArray.length
          }
          fontWeight={
            statusListchecked.length === statusArray.length
              ? "600 !important"
              : "500 !important"
          }
        />

        {statusArray
          .filter((status) => status !== "")
          .map((status) => (
            <CheckboxListItem
              key={status}
              item={status}
              isChecked={statusListchecked.includes(status)}
              onClick={handleStatusToggle(status)}
            />
          ))}
      </FilterListContainer>
      </FilterSectionWrapper>

      <FilterSectionWrapper id="category">
        <FilterSectionHeader
          isOpen={categoryOpen}
          onClick={handleCategoryClick}
          title="Categories"
          count={`${categoryListChecked.length}/${
            Object.keys(categoryObjectList).filter((item) => item !== "").length
          }`}
        />

      <SearchableFilterContainer
        isOpen={categoryOpen}
        searchPlaceholder="Search for Category"
        onSearchChange={handleCategorySearch}
        selectAllFlag={selectAllCategoryFlag}
        onUnselectClick={handleUnselectCategory}
      >
        <AllCheckboxItem
            onClick={handleAllCategoryToggle}
            checked={
              filteredCategory.length > 0 &&
              filteredCategory.every((item) =>
                categoryListChecked.includes(item)
              )
            }
            indeterminate={
              filteredCategory.some((item) =>
                categoryListChecked.includes(item)
              ) &&
              !filteredCategory.every((item) =>
                categoryListChecked.includes(item)
              )
            }
            fontWeight={
              categoryListChecked.length === filteredCategory.length
                ? "600 !important"
                : "500 !important"
            }
          />

          {filteredCategory
            .filter((category) => category !== "")
            .map((category) => (
              <CheckboxListItem
                key={category}
                item={category}
                isChecked={categoryListChecked.includes(category)}
                onClick={handleCategoryToggle(category)}
              />
            ))}
      </SearchableFilterContainer>
      </FilterSectionWrapper>

      <FilterSectionWrapper id="model">
        <FilterSectionHeader
          isOpen={modelOpen}
          onClick={handleModelClick}
          title="Models"
          count={`${modelListChecked.length}/${
            Object.keys(modelObjectList).filter((item) => item !== "").length
          }`}
        />

      <SearchableFilterContainer
        isOpen={modelOpen}
        searchPlaceholder="Search for Model"
        onSearchChange={handleModelSearch}
        selectAllFlag={selectAllModelFlag}
        onUnselectClick={handleUnselectModel}
      >
        <AllCheckboxItem
            onClick={handleAllModelToggle}
            checked={modelListChecked.length === filteredModel.length}
            indeterminate={
              modelListChecked.length > 0 &&
              modelListChecked.length < filteredModel.length
            }
            fontWeight={
              modelListChecked.length === filteredModel.length
                ? "600 !important"
                : "500 !important"
            }
          />

          {filteredModel
            .filter((model) => model !== "")
            .map((model) => (
              <CheckboxListItem
                key={model}
                item={model}
                isChecked={modelListChecked.includes(model)}
                onClick={handleModelToggle(model)}
              />
            ))}
      </SearchableFilterContainer>
      </FilterSectionWrapper>

      <FilterSectionWrapper id="ecu">
        <FilterSectionHeader
          isOpen={ecuOpen}
          onClick={handleECUClick}
          title="ECU Type"
          count={`${ecuListchecked.length}/${ECUTypesObjectList?.length || 0}`}
        />

      {(ECUTypesObjectList === undefined ||
        ECUTypesObjectList.length === 0) && (
        <Collapse in={ecuOpen} timeout="auto" unmountOnExit>
          <EmptyStateMessage message="No ECU Types Available" />
        </Collapse>
      )}

      {ECUTypesObjectList !== undefined && ECUTypesObjectList.length > 0 && (
        <SearchableFilterContainer
          isOpen={ecuOpen}
          searchPlaceholder="Search for ECU Type"
          onSearchChange={handleECUSearch}
          selectAllFlag={selectAllECUFlag}
          onUnselectClick={handleUnselectECU}
        >
          <AllCheckboxItem
              onClick={handleAllEcuToggle}
              checked={ecuListchecked.length === filteredECUTypes.length}
              indeterminate={
                ecuListchecked.length > 0 &&
                ecuListchecked.length < filteredECUTypes.length
              }
              fontWeight={
                ecuListchecked.length === filteredECUTypes.length
                  ? "600 !important"
                  : "500 !important"
              }
            />

            {filteredECUTypes
              .filter((ecu) => ecu !== "")
              .map((ecu) => (
                <CheckboxListItem
                  key={ecu}
                  item={ecu}
                  isChecked={ecuListchecked.includes(ecu)}
                  onClick={handleECUToggle(ecu)}
                />
              ))}
        </SearchableFilterContainer>
      )}
      </FilterSectionWrapper>

      <FilterSectionWrapper id="country">
        <FilterSectionHeader
          isOpen={countryOpen}
          onClick={handleCountryClick}
          title="Country"
          count={`${countryListchecked.length}/${countryObjectList.length}`}
        />

      <SearchableFilterContainer
        isOpen={countryOpen}
        searchPlaceholder="Search for Country"
        onSearchChange={handleCountrySearch}
        selectAllFlag={selectAllCountryFlag}
        onUnselectClick={handleUnselectCountry}
      >
        <AllCheckboxItem
            onClick={handleAllCountryToggle}
            checked={
              filteredCountry.length > 0 &&
              filteredCountry.every((item) =>
                countryListchecked.includes(item)
              )
            }
            indeterminate={
              filteredCountry.some((item) =>
                countryListchecked.includes(item)
              ) &&
              !filteredCountry.every((item) =>
                countryListchecked.includes(item)
              )
            }
            fontWeight={
              countryListchecked.length === filteredCountry.length
                ? "600 !important"
                : "500 !important"
            }
          />

          {filteredCountry
            .filter((country) => country !== "")
            .map((country) => (
              <CheckboxListItem
                key={country}
                item={country}
                isChecked={countryListchecked.includes(country)}
                onClick={handleCountryToggle(country)}
              />
            ))}
      </SearchableFilterContainer>
      </FilterSectionWrapper>

      <FilterSectionWrapper id="apiLevel">
        <FilterSectionHeader
          isOpen={ApiLevelOpen}
          onClick={handleApiLevelClick}
          title="API Level"
          count={`${apiLevelListchecked.length}/${apiObjectList?.length || 0}`}
        />

      <SearchableFilterContainer
        isOpen={ApiLevelOpen}
        helperText={apiObjectList.length > 0 ? "Greater than or Equal to" : undefined}
        searchPlaceholder="Search for API"
        onSearchChange={handleApiLevelSearch}
        selectAllFlag={selectAllApiFlag}
        onUnselectClick={handleUnselectApiLevel}
        searchValue={searchApiLevel}
      >
        <AllCheckboxItem
            onClick={handleAllApilevelToggle}
            checked={
              filteredApiLevel.length > 0 &&
              filteredApiLevel.every((item) =>
                apiLevelListchecked.includes(item)
              )
            }
            indeterminate={
              filteredApiLevel.some((item) =>
                apiLevelListchecked.includes(item)
              ) &&
              !filteredApiLevel.every((item) =>
                apiLevelListchecked.includes(item)
              )
            }
            fontWeight={
              apiLevelListchecked.length === filteredApiLevel.length
                ? "600 !important"
                : "500 !important"
            }
          />

          {filteredApiLevel
            .filter((api) => api !== "")
            .map((api) => (
              <CheckboxListItem
                key={api}
                item={api}
                isChecked={apiLevelListchecked.includes(api)}
                onClick={handleAPILevelToggle(api)}
              />
            ))}
      </SearchableFilterContainer>
      </FilterSectionWrapper>

      <FilterSectionWrapper id="payment">
        <FilterSectionHeader
          isOpen={paymentOpen}
          onClick={handlePaymentClick}
          title="Payments"
        />

      <FilterListContainer isOpen={paymentOpen}>
        <AllCheckboxItem
          onClick={handleAllPaymentToggle}
          checked={paymentListchecked.length === paymentArray.length}
          indeterminate={
            paymentListchecked.length > 0 &&
            paymentListchecked.length < paymentArray.length
          }
          fontWeight={
            paymentListchecked.length === paymentArray.length
              ? "600 !important"
              : "500 !important"
          }
        />

        {paymentArray
          .filter((payment) => payment !== "")
          .map((payment) => (
            <CheckboxListItem
              key={payment}
              item={payment}
              isChecked={paymentListchecked.includes(payment)}
              onClick={handlePaymentToggle(payment)}
            />
          ))}
      </FilterListContainer>
      </FilterSectionWrapper>
    </div>
  );
};

OEMDrawerFilterAll.propTypes = {
  categoryObjectList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  modelObjectList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  countryObjectList: PropTypes.array,
  ECUTypesObjectList: PropTypes.array,
  apiObjectList: PropTypes.array,
  channelOpen: PropTypes.bool,
  statusOpen: PropTypes.bool,
  categoryOpen: PropTypes.bool,
  modelOpen: PropTypes.bool,
  ecuOpen: PropTypes.bool,
  countryOpen: PropTypes.bool,
  ApiLevelOpen: PropTypes.bool,
  paymentOpen: PropTypes.bool,
  channelListchecked: PropTypes.array,
  statusListchecked: PropTypes.array,
  categoryListChecked: PropTypes.array,
  modelListChecked: PropTypes.array,
  ecuListchecked: PropTypes.array,
  countryListchecked: PropTypes.array,
  apiLevelListchecked: PropTypes.array,
  paymentListchecked: PropTypes.array,
  searchApiLevel: PropTypes.string,
  selectAllCategoryFlag: PropTypes.bool,
  selectAllModelFlag: PropTypes.bool,
  selectAllCountryFlag: PropTypes.bool,
  selectAllECUFlag: PropTypes.bool,
  selectAllApiFlag: PropTypes.bool,
  channelType: PropTypes.array,
  statusArray: PropTypes.array,
  paymentArray: PropTypes.array,
  handleChannelClick: PropTypes.func,
  handleStatusClick: PropTypes.func,
  handleCategoryClick: PropTypes.func,
  handleModelClick: PropTypes.func,
  handleECUClick: PropTypes.func,
  handleCountryClick: PropTypes.func,
  handleApiLevelClick: PropTypes.func,
  handlePaymentClick: PropTypes.func,
  handleChannelToggle: PropTypes.func,
  handleStatusToggle: PropTypes.func,
  handleCategoryToggle: PropTypes.func,
  handleModelToggle: PropTypes.func,
  handleECUToggle: PropTypes.func,
  handleCountryToggle: PropTypes.func,
  handleAPILevelToggle: PropTypes.func,
  handlePaymentToggle: PropTypes.func,
  handleAllChannelsToggle: PropTypes.func,
  handleAllStatusToggle: PropTypes.func,
  handleAllCategoryToggle: PropTypes.func,
  handleAllModelToggle: PropTypes.func,
  handleAllEcuToggle: PropTypes.func,
  handleAllCountryToggle: PropTypes.func,
  handleAllApilevelToggle: PropTypes.func,
  handleAllPaymentToggle: PropTypes.func,
  handleUnselectCategory: PropTypes.func,
  handleUnselectModel: PropTypes.func,
  handleUnselectECU: PropTypes.func,
  handleUnselectCountry: PropTypes.func,
  handleUnselectApiLevel: PropTypes.func,
  handleCategorySearch: PropTypes.func,
  handleModelSearch: PropTypes.func,
  handleECUSearch: PropTypes.func,
  handleCountrySearch: PropTypes.func,
  handleApiLevelSearch: PropTypes.func,
  filteredCategory: PropTypes.array,
  filteredModel: PropTypes.array,
  filteredECUTypes: PropTypes.array,
  filteredCountry: PropTypes.array,
  filteredApiLevel: PropTypes.array,
};
